import React, { useEffect, useState } from 'react'
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { gelleryData } from '../GelleryPage/dummay';
import { useParams } from 'react-router-dom';
function Banner() {
       const [index, setIndex] = useState(-1);
        const breakpoints = [3840, 1920, 1080, 640, 384, 256, 128];
        const assetLink = (url, width) => `${url}?w=${width}&q=75`;
        const [images1, setImages1] = useState([]);
        const imagesArray = images1?.map(item => ({
            asset: item,
            width: 3840,
            height: 3560,
        })) || [];
        const slides = imagesArray.map(({ asset, width, height }) => ({
            src: assetLink(asset, width),
            width,
            height,
            srcSet: breakpoints.map((breakpoint) => ({
                src: assetLink(asset, breakpoint),
                width: breakpoint,
                height: Math.round((height / width) * breakpoint),
            })),
        }));
        const [gelleryImages, setGelleryImage] = useState([]);
        const parms=useParams()
        useEffect(() => {
            const matchedGallery = gelleryData?.find(
                (item) => item?.slug === parms?.slug
            );
            setGelleryImage(matchedGallery?.imageData || []);
            setImages1(matchedGallery?.imageData?.flatMap(item => item.data.map(img => img.img)) || []);
            // eslint-disable-next-line
        }, [parms?.slug]);
  return (
    <div className='responsive-container'>
         <div className='row mx-3 my-5' style={{ overflow: "hidden" }}>
                {gelleryImages?.map((item, colIndex) => {
                    return (
                        <div className={`col-lg-3 p-0 px-1 d-flex ${colIndex % 2 === 0 ? "flex-column-reverse" : ""} flex-wrap`} key={colIndex}>
                            {item?.data?.map((items) => {
                                const isEven = items?.idx % 2 === 0;
                                const imageHeight = isEven ? "450px" : "300px";  // Alternate heights
                                return (
                                    <img
                                        key={items?.idx}
                                        src={items?.img}
                                        onClick={() => setIndex(items?.idx)}
                                        style={{
                                            width: "100%",
                                            marginBottom: ".5rem",
                                            height: imageHeight,
                                            objectFit: "cover",
                                            cursor: "pointer"
                                        }}
                                        alt='...'
                                    />
                                );
                            })}
                        </div>
                    );
                })}
            </div>

            <Lightbox
                plugins={[Counter, Fullscreen, Slideshow, Zoom, Thumbnails]} index={index} slides={slides} open={index >= 0} close={() => setIndex(-1)} />
    </div>
  )
}

export default Banner